import ApiClient from '@/libs/api_client';

export default {
  strict: true,
  namespaced: true,
  actions: {
    async signIn(context, params) {
      if (!params.email || !params.password) throw new Error();
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const response = await ApiClient.signIn(params);
        return response.data;
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async signOut(context) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const response = await ApiClient.signOut();
        return response.data;
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async signUp(context, params) {
      if (!params.email || !params.password) throw new Error();
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const response = await ApiClient.signUp(params);
        return response.data;
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async validateToken(context) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const response = await ApiClient.validateToken();
        return response.data;
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/models/user/sessions.js